import React from "react";
import PropTypes from "prop-types";

import _str from "shared/util/_str";
import Str from "shared/components/Str";

import SendTriggerMenu from "apps/messenger/containers/SendTriggerMenu";
import {
	SEND_TRIGGER_TYPE,
} from "apps/messenger/util/consts";

import "apps/messenger/components/MainWindow/Toolbar.scss";

const Toolbar = ({
	userid,
	sendDisabled,
	sendMessage,
	text,
	allowSendTriggerOptions,
	preferredSendTrigger,
}) => {
	const handleSend = () => sendMessage(userid);

	const shouldPressEnterToSend = allowSendTriggerOptions
		&& preferredSendTrigger === SEND_TRIGGER_TYPE.EnterToSend;

	return (
		<div className="messenger-toolbar">
			<div className="messenger-toolbar-spacer" />
			{shouldPressEnterToSend ? (
				<Str className="messenger-toolbar-enter-to-send">
					Press enter to send
				</Str>
			) : (
				<button
					className="messenger-toolbar-send"
					disabled={sendDisabled}
					onClick={handleSend}
				>
					{text}
				</button>
			)}
			{allowSendTriggerOptions && (
				<SendTriggerMenu />
			)}
		</div>
	);
};

Toolbar.propTypes = {
	userid: PropTypes.string.isRequired,

	sendMessage: PropTypes.func.isRequired,
	sendDisabled: PropTypes.bool.isRequired,
	allowSendTriggerOptions: PropTypes.bool,
	preferredSendTrigger: PropTypes.oneOf(Object.values(SEND_TRIGGER_TYPE)),
	text: PropTypes.string,
};

Toolbar.defaultProps = {
	allowSendTriggerOptions: false,
	preferredSendTrigger: SEND_TRIGGER_TYPE.ClickToSend,
	text: _str("Send"),
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Toolbar.jsx